import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { categoryDetailAdvancedSeoCategoriesItemTwClass } from 'components/Pages/CategoryDetail/CategoryDetailAdvancedSeoCategories/CategoryDetailAdvancedSeoCategories';
import useEmblaCarousel from 'embla-carousel-react';
import { twJoin } from 'tailwind-merge';
import { ReadyCategorySeoMixLink } from 'types/category';

type Props = {
    readyCategorySeoMixLinks: ReadyCategorySeoMixLink[];
};

const CategoryDetailAdvancedSeoCategoriesSlider: FC<Props> = ({ readyCategorySeoMixLinks }) => {
    const [emblaRef] = useEmblaCarousel({
        align: 'start',
        containScroll: 'trimSnaps',
        loop: false,
        duration: 20,
    });

    return (
        <div className="mb-7 overflow-hidden" ref={emblaRef}>
            <div className="flex whitespace-nowrap">
                {readyCategorySeoMixLinks.map((seoMixLink, index) => {
                    /* TODO: this should be done on BE */
                    const slash = seoMixLink.slug[0] !== '/' ? '/' : '';

                    return (
                        <ExtendedNextLink
                            key={index}
                            href={slash + seoMixLink.slug}
                            className={twJoin(
                                categoryDetailAdvancedSeoCategoriesItemTwClass(),
                                'ml:4 w-[calc(100vw/1.2-40px)] flex-shrink-0 flex-grow whitespace-normal md:w-[calc(100vw/2.2-40px)] lg:w-auto',
                            )}
                            type="static"
                        >
                            {seoMixLink.name}
                        </ExtendedNextLink>
                    );
                })}
            </div>
        </div>
    );
};

export default CategoryDetailAdvancedSeoCategoriesSlider;
